<span class="breadcrumb-toggle" [class.show]="isShow">
  <a class="btn btn-back pl-0" (click)="toggleShow()">
    <i class="icon-arrow-left"></i>
  </a>
  <div class="card">
    <div class="card-body">
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let breadcrumb of breadcrumbs; let i = index; trackById">
          <a class="btn btn-breadcrumb" [routerLink]="breadcrumb.url" routerLinkActive="router-link-active" [class.disabled]="i===(breadcrumbs.length-1)">
            <p>{{ breadcrumb.label | translate}}</p>
            <i [class]="breadcrumb.icon"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</span>